function BerniePluginPolyfill() {
  return {
    name: 'bernie-plugin-polyfill'
  };
}
export { BerniePluginPolyfill as default };